import { i18n } from '@secret-escapes/i18n';
import { ITranslationObject } from '../../../common/types';
import { ISale } from '../../../common/types/apiSchema';

const TIMES_BOOKED_LOWER_LIMIT: number = 20;
const TIMES_BOOKED_UPPER_LIMIT: number = 100;
const SHOW_VIEWINGS_THRESHOLD: number = 0;
const POPULAR_THRESHOLD: number = 10;

export { getNumberOfBookings, getPeopleViewing, POPULAR_THRESHOLD };

/**
 * Returns people viewing
 */
const getPeopleViewing: (currentVisitors: number, translations: ITranslationObject) => string = (
  currentVisitors,
  translations
) => {
  let peopleViewingText: string = '';

  if (currentVisitors > POPULAR_THRESHOLD) {
    peopleViewingText = i18n('sale.currentVisitors.popular', [currentVisitors], translations);
  } else if (currentVisitors > SHOW_VIEWINGS_THRESHOLD) {
    peopleViewingText = i18n('sale.currentVisitors.label', [currentVisitors], translations);
  }

  return peopleViewingText;
};

/**
 * Returns number of bookings
 */
const getNumberOfBookings: (sale: ISale, translations: ITranslationObject) => string = (
  sale,
  translations
) => {
  let numberOfBookingsText: string = '';
  const timesBooked: number = sale.bookingStats ? sale.bookingStats.timesBooked : null;

  if (timesBooked >= TIMES_BOOKED_UPPER_LIMIT) {
    numberOfBookingsText = i18n('sale.timesBooked.upper.limit', [], translations);
  } else if (timesBooked >= TIMES_BOOKED_LOWER_LIMIT) {
    numberOfBookingsText = i18n('sale.timesBooked.lower.limit', [timesBooked], translations);
  }

  return numberOfBookingsText;
};
